'use strict';

function containerDirective () {

  function link ($scope, $el, attrs, ctrl) {
    ctrl.init();
  }

  return {
    bindToController: true,
    controller: 'ButtonContainerController',
    controllerAs: 'buttonContainerCtrl',
    link: link,
    restrict: 'A',
    scope: {
      delay: '@', // delay in milliseconds before next button is shown
      show: '=?', // true to show the buttons, defaults to true
      stack: '@', // 'true' or 'false'
    },
    templateUrl: 'saturn/button/buttonContainer/buttonContainer.tpl.html',
    transclude: true
  };
}

module.exports = containerDirective;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/button/src/buttonContainer/ButtonContainerDirective.js